<template>
  <div class="section">
    <div class="container">
      <ui-page-hero
        id="id_title_reservations"
        :title="'Reservations'"
      >
      </ui-page-hero>

      <template>
        <div class="tabs is-boxed">
          <ul>
            <li
              id="id_tabs_reservations"
              v-for="mt in meetingtypes"
              @click="selectedMeetingtype = mt.id"
              :class="{
                'is-active': mt.id === selectedMeetingtype
              }"
              :key="mt.id"
            >
              <a>{{ mt.name }}</a>
            </li>
          </ul>
        </div>

        <transition name="slide-fade" mode="out-in">
          <ReservationList
            class="reservation-list"
            :locationId="locationId"
            :selectedMeetingtype="selectedMeetingtype"
          />
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import ReservationList from '@/components/Reservations/ReservationList'

export default {
  name: 'reservations',

  components: {
    ReservationList
  },

  data() {
    return {
      customerId: 0,
      locationId: Number(this.$route.params.locationId),
      meetingtypes: [
        {id: 1, name: 'Meeting room'},
        {id: 2, name: 'Workspace'}
    ],

      selectedMeetingtype: 1,
    };
  },

  computed: {
  },

  provide() {
    const currentDate = new Date();
    let startDate = new Date(
      currentDate.getFullYear() - 1,
      currentDate.getMonth(),
      currentDate.getDate()
    );
    let endDate = new Date(
      currentDate.getFullYear() + 2,
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const searchTermDateRange = {
      start: startDate,
      end: endDate
    };
    return {
      showNoDateSelection: false,
      searchTermDateRange
    };
  },

  mounted() {
  },

  beforeDestroy() {},

  methods: {
    getMeetingtypeName(id) {
      let arr = {
        1: 'Meeting room',
        2: 'Workspace'
      };
      return arr[id];
    }
  }
};
</script>

<style lang="scss" scoped></style>
